/* Retires the former 80 EUR promotion. Never adds a product or changes a paid line. */
(function () {
  'use strict';
  const VARIANT = '56873593176329';
  const isRetiredGift = (item) => String(item.variant_id) === VARIANT &&
    (item.properties?._karly_free_gift === 'true' || item.properties?._karly_free_gift === true);

  function createCleaner(fetcher, root) {
    let pending;
    async function request(path, options = {}) {
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 10000);
      try {
        const response = await fetcher(root + path, {
          credentials: 'same-origin', cache: 'no-store', ...options, signal: controller.signal
        });
        if (!response.ok) throw new Error('Cart request failed');
        const cart = await response.json();
        if (!Array.isArray(cart.items)) throw new Error('Invalid cart response');
        return cart;
      } finally { clearTimeout(timer); }
    }
    return function clean() {
      if (pending) return pending;
      pending = (async () => {
        const cart = await request('cart.js');
        const gifts = cart.items.filter(isRetiredGift);
        if (!gifts.length) return { changed: false, cart };
        if (gifts.some((item) => typeof item.key !== 'string' || !item.key)) {
          throw new Error('Missing line key');
        }
        // Line keys keep a separately purchased copy of the same variant untouched.
        await request('cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: Object.fromEntries(gifts.map((item) => [item.key, 0])) })
        });
        const verified = await request('cart.js');
        if (verified.items.some(isRetiredGift)) throw new Error('Retired gift still present');
        return { changed: true, cart: verified };
      })().finally(() => { pending = undefined; });
      return pending;
    };
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { isRetiredGift, createCleaner };
    return;
  }
  if (window.karlyRetiredGiftInstalled) return;
  window.karlyRetiredGiftInstalled = true;
  const root = window.Shopify?.routes?.root || '/';
  const clean = createCleaner(window.fetch.bind(window), root);
  const html = document.documentElement;
  let checking;
  let reloading = false;
  let permittedForm = null;
  let checkoutPending = false;
  const noticeId = 'karly-cart-retirement-notice';

  function showNotice(message, retry) {
    document.getElementById(noticeId)?.remove();
    const notice = document.createElement('div');
    notice.id = noticeId;
    notice.className = 'karly-cart-retirement-notice';
    notice.setAttribute('role', retry ? 'alert' : 'status');
    const text = document.createElement('span');
    text.textContent = message;
    notice.append(text);
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = retry ? 'Erneut prüfen' : 'Schließen';
    button.addEventListener('click', retry ? () => check() : () => notice.remove());
    notice.append(button);
    document.body.append(notice);
  }

  function check() {
    if (checking) return checking;
    if (reloading) return Promise.resolve(false);
    html.classList.add('karly-gift-checking');
    checking = clean().then(({ changed }) => {
      if (changed) {
        reloading = true;
        try { sessionStorage.setItem('karly-retired-gift-removed', '1'); } catch (_) { /* storage optional */ }
        // Refresh all cart forms and totals; never submit stale line quantities.
        window.location.reload();
        return false;
      }
      html.classList.remove('karly-gift-checking', 'karly-gift-check-failed');
      document.getElementById(noticeId)?.remove();
      document.querySelectorAll('[data-karly-legacy-gift-blocked]').forEach((button) => {
        button.disabled = false;
        button.removeAttribute('data-karly-legacy-gift-blocked');
      });
      return true;
    }).catch(() => {
      html.classList.remove('karly-gift-checking');
      html.classList.add('karly-gift-check-failed');
      showNotice('Dein Warenkorb konnte noch nicht geprüft werden. Bitte versuche es vor dem Bezahlen erneut.', true);
      return false;
    }).finally(() => { checking = undefined; });
    return checking;
  }

  document.addEventListener('submit', async (event) => {
    if (event.submitter?.name !== 'checkout') return;
    if (permittedForm === event.target) { permittedForm = null; return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutPending) return;
    checkoutPending = true;
    const form = event.target;
    const submitter = event.submitter;
    try {
      if (await check()) {
        permittedForm = form;
        form.requestSubmit(submitter);
        permittedForm = null;
      }
    } finally { checkoutPending = false; }
  }, true);

  document.addEventListener('click', async (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    const url = new URL(link.href, window.location.href);
    if (url.origin !== window.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?checkout\/?$/i.test(url.pathname)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (checkoutPending) return;
    checkoutPending = true;
    try { if (await check()) window.location.assign(url.href); }
    finally { checkoutPending = false; }
  }, true);

  const cartChanged = (cart) => { if (cart?.items?.some(isRetiredGift)) check(); };
  if (window.theme?.pubsub?.subscribe) {
    window.theme.pubsub.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, (event) => cartChanged(event.cart));
  }
  document.addEventListener('cart:updated', (event) => cartChanged(event.detail?.cart));
  window.addEventListener('pageshow', (event) => { if (event.persisted) check(); });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') check(); });
  let removedOnPreviousPage = false;
  try {
    removedOnPreviousPage = sessionStorage.getItem('karly-retired-gift-removed') === '1';
    sessionStorage.removeItem('karly-retired-gift-removed');
  } catch (_) { /* storage optional */ }
  check().then((ready) => {
    if (ready && removedOnPreviousPage) {
      showNotice('Die ehemalige Gratiszugabe wurde aus deinem Warenkorb entfernt. Deine ausgewählten Artikel bleiben erhalten.', false);
    }
  });
})();
